import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

class DropdownMenuItem extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick(this.props.value);
  }

  render() {
    let item = (
      <NavLink to={this.props.path} className="dropdown-menu__item">
        {this.props.label}
      </NavLink>
    );

    const itemProps = {
      onClick: this.onClick,
    };

    if (this.props.type === 'BUTTON') {
      item = (
        <div
          className={classnames('dropdown-menu__item', this.props.className)}
          {...itemProps}
        >
          {this.props.label}
        </div>
      );
    }

    return item;
  }
}

DropdownMenuItem.defaultProps = {
  label: '',
  path: '',
  type: 'LINK',
  onClick: () => {},
  value: '',
};

DropdownMenuItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  path: PropTypes.string,
  type: PropTypes.oneOf(['LINK', 'BUTTON']),
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DropdownMenuItem;
